import { classnames } from 'Utils/classnames/classnames.utils';

export const themes = ({
  isBestPrice,
  isHighlighted,
  isSelectable,
  isSelected,
  isTablet,
  lastAvailability,
  shouldDisplayDoubleSeasonButton,
  siblingOpen,
}) => ({
  default: {
    thDay: classnames(
      `group flex flex-1 cursor-pointer flex-col items-center justify-center ${
        isTablet ? 'h-100 p-5' : 'h-52'
      } relative border-r border-t border-grey text-center text-14 transition-all duration-250 ease-in`,
      { 'text-black hocus:text-white': isSelectable },
    ),
    thDayCornerMark: classnames({
      'corner-mark-tr-turquoise': siblingOpen && isTablet,
      'corner-mark-tr-turquoise-sm': siblingOpen && !isTablet,
    }),
    thDayMessage: 'hidden md:inline w-full font-normal text-12',
    thDayNumber: classnames('left-0 top-0 text-10 md:absolute md:p-5', {
      'font-normal md:text-12': !isSelectable,
      'font-bold md:text-16': isSelectable,
      'text-current': siblingOpen,
    }),
    thDayOldPrice: 'text-12 line-through hidden md:block text-current',
    thDayPrice: 'text-12 md:text-16',
    thStatusMessage: shouldDisplayDoubleSeasonButton
      ? `bg-turquoise cursor-pointer font-bold p-1 md:px-5 rounded-2 text-10 md:text-18 text-white uppercase${
          !isTablet ? ' w-full' : ''
        }`
      : 'hidden md:inline w-full font-normal',
    thFrom: 'hidden md:inline w-full font-normal',
  },
  compact: {
    thDay:
      'cursor-pointer flex flex-1 flex-col group items-center justify-center h-48 leading-tight relative text-14 text-center',
    thDayMessage: 'hidden',
    thDayNumberContainer: classnames('relative isolate'),
    thDayNumber: classnames('relative z-1', {
      'text-white': (lastAvailability || isBestPrice || siblingOpen) && isHighlighted,
      'text-grey group-hover:text-white':
        !lastAvailability && !isBestPrice && !siblingOpen && isHighlighted,
    }),
    thDayUnavailable: 'line-through',
    thDayHighlight:
      'absolute bg-current group-hover:bg-transparent h-26 left-1/2 rounded-4 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-26',
    thDayOldPrice: 'hidden',
    thDayPrice: classnames('mx-auto -mb-5 mt-5 block self-end text-10 font-bold', {
      'text-black group-hover:text-white': !isSelected,
      'text-white': isSelected,
    }),
    thStatusMessage: 'hidden',
    thFrom: 'hidden',
    thShowPricePlaceholder: true,
  },
});
